import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getCollectionKey, getCollectionsKey, getSpacesKey, } from '../../utils/keys';
export const useOrganizeSpacesInCollection = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation((input) => client.collections.organizeSpaces(input), {
        onSettled: (data, error, { collectionId }) => {
            const spacesKey = getSpacesKey({ variables: { collectionId } });
            queryClient.invalidateQueries(spacesKey);
            const collectionKey = getCollectionKey({
                variables: { id: collectionId },
            });
            queryClient.invalidateQueries(collectionKey);
            const collectionsKey = getCollectionsKey();
            queryClient.invalidateQueries(collectionsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useOrganizeSpacesInCollection.js.map